import { component as defineComponent } from 'flightjs';
import withUploader from 'app/modules/mixins/with-uploader';

export default defineComponent(withUploader);



// WEBPACK FOOTER //
// ./src/web/js/app/modules/file-uploader.js